import type { DemoKey } from '../types';

export const ro: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Demo LearnForge',
  'app.title': 'Statistică',
  'panel.experiment': 'Experiment',
  'panel.params': 'Parametri',

  'exp.survey-explorer.title': 'Explorator de date',
  'exp.survey-explorer.desc': 'Alege o coloană; demo-ul alege rezumatul potrivit.',
  'exp.distribution-sculptor.title': 'Sculptor de distribuții',
  'exp.distribution-sculptor.desc': 'Mută punctele și vezi cum reacționează statisticile.',
  'exp.two-variable-lab.title': 'Laborator bivariat',
  'exp.two-variable-lab.desc': 'Scatter, regresie, corelație vs cauzalitate.',
  'exp.sampling-lab.title': 'Laborator de eșantionare',
  'exp.sampling-lab.desc': 'Cum afectează tehnica și mărimea media eșantionului.',
  'exp.probability-diagrams.title': 'Diagrame de probabilitate',
  'exp.probability-diagrams.desc': 'Vederi Venn și arbore pentru evenimente compuse.',

  'type.qualitative-nominal.label': 'Calitativ · nominal',
  'type.qualitative-nominal.def': 'Categorii fără ordine intrinsecă.',
  'type.qualitative-ordinal.label': 'Calitativ · ordinal',
  'type.qualitative-ordinal.def': 'Categorii cu o ordine semnificativă.',
  'type.qualitative-multi.label': 'Calitativ · multi-valoare',
  'type.qualitative-multi.def': 'Fiecare observație poate avea mai multe etichete.',
  'type.quantitative-discrete.label': 'Cantitativ · discret',
  'type.quantitative-discrete.def': 'Numere care vin în pași fixați.',
  'type.quantitative-continuous.label': 'Cantitativ · continuu',
  'type.quantitative-continuous.def': 'Numere măsurate pe o scară continuă.',

  'column.name.label': 'Nume elev',
  'column.height_cm.label': 'Înălțime',
  'column.shoe_size_eu.label': 'Mărime pantof (EU)',
  'column.study_hours.label': 'Ore de studiu / săptămână',
  'column.test_score.label': 'Notă test',
  'column.sports_played.label': 'Sporturi practicate',
  'column.eye_color.label': 'Culoare ochi',
  'column.commute_min.label': 'Naveta',
  'column.grade_year.label': 'Clasa',
  'column.homework_effort.label': 'Efort la teme',
  'column.ice-cream-sales.label': 'Vânzări de înghețată',
  'column.drownings.label': 'Înecuri',
  'column.month.label': 'Lună',
  'column.storks.label': 'Berze',
  'column.births.label': 'Nașteri',
  'column.country_area_km2.label': 'Suprafața țării',
  'column.sleep_hours.label': 'Ore de somn',
  'column.reaction_ms.label': 'Timp de reacție',

  'dataset.master-survey.label': 'Sondaj clasă',
  'dataset.master-survey.desc': '30 de elevi simulați.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Vânzări înghețată vs înecuri',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Ambele cresc și scad cu sezonul. Înecurile nu cauzează vânzările de înghețată.',
  'dataset.spurious-storks-vs-births.label': 'Berze vs nașteri',
  'dataset.spurious-storks-vs-births.desc':
    'Țările mari au mai multe berze și mai multe nașteri. Păsările nu sunt cauza.',
  'dataset.real-sleep-vs-reaction-time.label': 'Somn vs timp de reacție',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Mai mult somn, reacții mai rapide. O corelație negativă reală — și un mecanism plauzibil.',

  'tag.football.label': 'Fotbal',
  'tag.basketball.label': 'Baschet',
  'tag.volleyball.label': 'Volei',
  'tag.swimming.label': 'Înot',
  'tag.none.label': 'Niciunul',

  'population.gaussian.label': 'Clopot Gauss',
  'population.right-skewed.label': 'Asimetric la dreapta',
  'population.bimodal.label': 'Bimodal (cu straturi)',
  'population.uniform.label': 'Uniform',

  'venn.dice-even-or-prime.label': 'Zar: par sau prim',
  'venn.class-sports-2set.label': 'Sporturi (2 mulțimi)',
  'venn.class-sports-3set.label': 'Sporturi (3 mulțimi)',
  'venn.custom.label': 'Personalizat',

  'tree.draw-without-replacement.label': 'Extragere fără înlocuire',
  'tree.custom.label': 'Personalizat',
  'tree.coin.heads': 'C',
  'tree.coin.tails': 'P',
  'tree.draw.start': 'Sac: 2 roșii, 3 albastre',
  'tree.draw.red': 'Roșu',
  'tree.draw.blue': 'Albastru',
  'tree.custom.start': 'Start',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histogramă',
  'card.cumulative': 'Frecvență cumulativă',
  'card.box': 'Diagramă box-and-whisker',
  'card.summary': 'Rezumat 5 numere',
  'card.bar': 'Grafic cu bare',
  'card.mode': 'Modul',
  'card.tag-frequency': 'Frecvența etichetelor',
  'card.mode-tag': 'Etichetă dominantă',
  'card.empty-no-order': 'Nu se aplică',
  'card.empty-multi': 'Nu se aplică',
  'card.numberline': 'Axa numerelor',
  'card.scatter': 'Scatter',
  'card.description': 'Ce se întâmplă',
  'card.population': 'Populație',
  'card.sampling-distribution': 'Medii de eșantion',
  'card.venn': 'Venn',
  'card.tree': 'Arbore',
  'card.probabilities': 'Probabilități',

  'param.dataset.label': 'Set de date',
  'param.column.label': 'Coloană',
  'param.bins.label': 'Intervale',
  'param.shape.label': 'Formă inițială',
  'param.show-mean.label': 'Arată media',
  'param.show-median.label': 'Arată mediana',
  'param.x-col.label': 'Coloană X',
  'param.y-col.label': 'Coloană Y',
  'param.show-regression.label': 'Linia de regresie',
  'param.show-residuals.label': 'Reziduuri',
  'param.show-confounder.label': 'Arată factorul de confuzie',
  'param.population.label': 'Populație',
  'param.technique.label': 'Tehnică',
  'param.sample-size.label': 'Mărime eșantion',
  'param.stratum.label': 'Strat',
  'param.bias.label': 'Bias',
  'param.mode.label': 'Mod',
  'param.preset.label': 'Preset',
  'param.universe.label': 'Mărime univers',
  'param.show-prob.label': 'Arată probabilitățile',
  'param.treat-as-numeric.label': 'Tratează ca numeric',

  'stat.count': 'Număr',
  'stat.mean': 'Medie',
  'stat.median': 'Mediană',
  'stat.range': 'Interval',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IIQ',
  'stat.outliers': 'Valori aberante',
  'stat.r': 'Pearson r',
  'stat.r2': 'r²',
  'stat.slope': 'Pantă',
  'stat.intercept': 'Intercept',
  'stat.n': 'n',
  'stat.population-mean': 'Media adevărată',
  'stat.latest-sample-mean': 'Media eșantionului',
  'stat.sample-mean-spread': 'AS media eșantionului',
  'stat.sample-count': 'Eșantioane extrase',
  'outlier.upper': 'Valori aberante superioare',
  'outlier.lower': 'Valori aberante inferioare',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Reesantion',
  'btn.run-100': 'Rulează 100 eșantioane',
  'btn.stop': 'Stop',
  'btn.clear-history': 'Șterge istoric',

  'explainer.no-order': 'Fără ordine → fără cumulativă, fără box plot.',
  'explainer.multi-no-iqr': 'Multi-valoare → cuartile / IIQ nu sunt definite.',
  'message.no-data': 'Fără date.',
  'message.needs-quartiles': 'Nevoie de ≥4 puncte pentru cuartile.',
  'message.x-zero-variance': 'X are varianță zero — nu se poate ajusta o linie.',
  'message.n-too-small': 'n prea mic.',
  'message.stratum-clamp': 'Stratul avea mai puține rânduri decât cerut — folosite toate.',
  'message.siblings-sum-to-one': 'Frații trebuie să însumeze 1.',
};
